
import memberRules from './member_rules.json';
import neetsRules from './neets_rules.json';
import cwdRules from './cwd_rules.json';

function getRules(type) {
  switch ((type || 'member').toLowerCase()) {
    case 'neets':
      return neetsRules;
    case 'cwd':
      return cwdRules;
    default:
      return memberRules;
  }
}

function getFieldValue(obj, path) {
  if (!obj || !path) return undefined;
  return path.split('.').reduce((acc, part) => (acc && acc[part] !== undefined) ? acc[part] : undefined, obj);
}

function evaluateOperator(leftVal, operator, rightVal, filterKey = null) {
  if (operator === "NOT_EMPTY") return Array.isArray(leftVal) ? leftVal.length > 0 : (leftVal !== null && leftVal !== undefined && leftVal !== "");
  if (operator === "IS_EMPTY") return Array.isArray(leftVal) ? leftVal.length === 0 : (leftVal === null || leftVal === undefined || leftVal === "");
  if (operator === "NOT_INCLUDE") {
    if (!Array.isArray(leftVal) || leftVal.length === 0) return false;
    return !leftVal.some(item => item && item.code === rightVal);
  }
  if (operator === "INCLUDE") {
    if (!Array.isArray(leftVal) || leftVal.length === 0) return false;
    return leftVal.some(item => item && item.code === rightVal);
  }
  if (operator === "MATCH_GENDER") {
    if (!leftVal || !rightVal) return false;
    if (rightVal === "อื่นๆ") return true;
    const gender = String(rightVal).trim().toLowerCase();
    const maleGenderValues = ["ชาย"];
    const femaleGenderValues = ["หญิง"];
    const malePrefixes = ["นาย", "เด็กชาย"];
    const femalePrefixes = ["นาง", "นางสาว", "เด็กหญิง"];

    if (malePrefixes.includes(leftVal)) {
      return maleGenderValues.includes(gender);
    }
    if (femalePrefixes.includes(leftVal)) {
      return femaleGenderValues.includes(gender);
    }

    return false;
  }
  //object
  if (operator === "OBJECT_INCLUDE") {
    if (typeof leftVal !== "object" || leftVal === null) return false;
    return leftVal[filterKey] === rightVal
  }
  if (operator === "BETWEEN") {
    if (!Array.isArray(rightVal) || rightVal.length !== 2) return false;
    let leftNumber = leftVal;
    if (typeof leftVal === "object" && leftVal !== null && leftVal.year !== undefined && leftVal.month !== undefined) {
      leftNumber = Number(leftVal.year) * 12 + Number(leftVal.month);
    }
    const [min, max] = rightVal.map(Number);
    return Number(leftNumber) >= min && Number(leftNumber) <= max;
  }
  if (operator === "==") return leftVal === rightVal;
  if (operator === "!=") return leftVal !== rightVal;
  if (operator === "IN") {
    if (!Array.isArray(rightVal)) return false;
    if (Array.isArray(leftVal)) {
      return leftVal.some(item => rightVal.includes(item));
    }
    return rightVal.includes(leftVal);
  }
  if (operator === "NOT_ALL_MATCH") {
    if (!Array.isArray(leftVal) || !Array.isArray(rightVal)) return false;
    return !leftVal.every((item, idx) => item === rightVal[idx]);
  }
  if (operator === "ANY_NOT_EMPTY") {
    if (!Array.isArray(leftVal)) return false;
    return leftVal.some(item => item !== null && item !== undefined && item !== "");
  }
  if (operator === ">=") return Number(leftVal) >= Number(rightVal);
  if (operator === "<=") return Number(leftVal) <= Number(rightVal);
  if (operator === ">") return Number(leftVal) > Number(rightVal);
  if (operator === "<") return Number(leftVal) < Number(rightVal);
  return false;
}

const DataResolvers = {
  "STATIC": (config) => config.value,
  "FIELD": (config, targetData) => getFieldValue(targetData, config.field),
  "ARRAY_FIND": (config, targetData) => {
    const arrayData = targetData[config.arrayName] || [];
    const foundItem = arrayData.find(item => item.code === config.findValue);
    return foundItem ? (Number(foundItem[config.returnField]) || 0) : 0;
  },
  "MULTI_FIELD": (config, targetData) => {
    if (!config.fields || !Array.isArray(config.fields)) return [];
    return config.fields.map(field => getFieldValue(targetData, field));
  },
  "ARRAY_COUNT": (config, targetData) => {
    let arrayData = config.arrayName ? targetData[config.arrayName] : targetData;
    if (!Array.isArray(arrayData)) return 0;
    if (config.nestedArrayField) {
      let parentItems = arrayData;
      if (config.codeField && config.targetCodes) {
        parentItems = arrayData.filter(item => config.targetCodes.includes(item[config.codeField]));
      }
      
      let nestedData = [];
      parentItems.forEach(item => {
        if (Array.isArray(item[config.nestedArrayField])) {
          nestedData = nestedData.concat(item[config.nestedArrayField]);
        }
      });
      arrayData = nestedData;
    }

    return arrayData.filter(item => {
      if (config.filters && Array.isArray(config.filters)) {
        return config.filters.every(cond => {
          const val = getFieldValue(item, cond.field);
          const compareVal = cond.valueField ? getFieldValue(item, cond.valueField) : cond.value;
          return evaluateOperator(val, cond.operator, compareVal);
        });
      }
      
      if (config.filterField) {
        const val = getFieldValue(item, config.filterField);
        const compareVal = config.valueField ? getFieldValue(item, config.valueField)
          : config.filterValueField ? getFieldValue(targetData, config.filterValueField)
          : config.filterValue;
        return evaluateOperator(val, config.filterOperator, compareVal);
      }
      
      return true;
    }).length;
  },
  "ARRAY_SUM": (config, targetData) => {
    const arrayData = config.arrayName ? targetData[config.arrayName] : targetData;
    if (!Array.isArray(arrayData)) return 0;

    return arrayData.reduce((sum, item) => {
      if (config.codeField && config.targetCodes) {
        if (!config.targetCodes.includes(item[config.codeField])) return sum;
      }
      if (config.nestedArrayField && Array.isArray(item[config.nestedArrayField])) {
        const nestedSum = item[config.nestedArrayField].reduce((nSum, nItem) => {
          return nSum + (Number(nItem[config.sumField]) || 0);
        }, 0);
        return sum + nestedSum;
      }

      return sum + (Number(item[config.sumField]) || 0);
      
    }, 0);
  }
};

function resolveData(config, members) {
  if (!config || !DataResolvers[config.type]) return null;
  // const targetData = config.source === "MEMBERS" ? members : household;
  
  return DataResolvers[config.type](config, members); 
}


const validateSurveyData = (type, surveyData) => {
  // support validateSurveyData(type, data) or validateSurveyData(data)
  const rulesConfig = getRules(type);
  return new Promise((resolve) => {
    const errors = [];
    const members = surveyData || [];

    for (const rule of rulesConfig) {
        //the condition is the question need to answer before validate the rule, if the condition is not meet, the rule validation will be ignore ex. answer HH105 must not empty before validate HH106
        if (rule.condition) {
          let conditionMatch = true;
          if (Array.isArray(rule.condition)) {
            conditionMatch = rule.condition.every(cond => {
              const leftVal = resolveData(cond.left, members);
              const rightVal = resolveData(cond.right, members);
              return evaluateOperator(leftVal, cond.operator, rightVal);
            });
          } else {
            const leftVal = resolveData(rule.condition.left, members);
            const rightVal = resolveData(rule.condition.right, members);
            conditionMatch = evaluateOperator(leftVal, rule.condition.operator, rightVal);
          }

          if (!conditionMatch) continue;
        }

      if (rule.validation) {
        let validationMatch = true;
        if (Array.isArray(rule.validation)) {
          validationMatch = rule.validation.every(cond => {
            const leftVal = resolveData(cond.left, members);
            const rightVal = resolveData(cond.right, members);
            return evaluateOperator(leftVal, cond.operator, rightVal);
          });
        } else {
          const leftVal = resolveData(rule.validation.left, members);
          const rightVal = resolveData(rule.validation.right, members);
          validationMatch = evaluateOperator(leftVal, rule.validation.operator, rightVal);
        }

        if (!validationMatch) {
          errors.push({
            ruleId: rule.ruleId,
            message: rule.errorMessage,
            questionCode: rule.questionCode,
            step: rule.step
          });
        }
      }
    }

    resolve({ 
        isPass: errors.length === 0, 
        errors: errors
    });
  });
};

export { validateSurveyData };